import MultipleChoice from "./MultipleChoice";
import OrdineIngrediente from "./OrdineIngrediente";
import OrdineStatoCompletamento from "./OrdineStatoCompletamento";
import SingleChoice from "./SingleChoice";
import Choice from "./Choice";
import ArticoloRimosso from "./ArticoloRimosso";

export class OrdineSingolo {
    nomeAlimento: string;
    quantita: number;
    costo: number;
    ingredienti: OrdineIngrediente[];
    multipleChoice: MultipleChoice[];
    singleChoice: SingleChoice[];
    choice: Choice[];
    statoCompletamento: OrdineStatoCompletamento[];
    articoloId: string;
    articoloRimossoList: ArticoloRimosso[];
    uscita?: number;
    nota?: string;

    constructor() {
        this.nomeAlimento = "";
        this.quantita = 0;
        this.costo = 0;
        this.ingredienti = [];
        this.multipleChoice = [];
        this.singleChoice = [];
        this.statoCompletamento = [];
        this.articoloId = "";
        this.choice = [];
        this.articoloRimossoList = [];
        this.uscita = 1;
        this.nota = "";
    }

    static convertFromFirestore(object: firebase.firestore.DocumentData): OrdineSingolo {
        let result: OrdineSingolo = new OrdineSingolo();
        result.nomeAlimento = object.nomeAlimento;
        result.quantita = object.quantita;
        result.costo = object.costo;
        result.articoloId = object.articoloId ?? "";

        if (object.ingredienti) {
            object.ingredienti.forEach((ingrediente: any) => {
                result.ingredienti.push(OrdineIngrediente.convertFromFirestore(ingrediente));
            });
        }

        /*if (object.multipleChoice) {
            object.multipleChoice.forEach((choice: any) => {
                result.multipleChoice.push(MultipleChoice.convertFromFirestore(choice));
            });
        }

        if (object.singleChoice) {
            object.singleChoice.forEach((choice: any) => {
                result.singleChoice.push(SingleChoice.convertFromFirestore(choice));
            });
        }*/

        if (object.choice) {
            object.choice.forEach((choice: any) => {
                result.choice.push(Choice.convertFromFirestore(choice));
            });
        }

        if (object.statoCompletamento) {
            object.statoCompletamento.forEach((choice: any) => {
                result.statoCompletamento.push(OrdineStatoCompletamento.convertFromFirestore(choice));
            });
        }

        if (object.articoloRimossoList) {
            object.articoloRimossoList.forEach((articolo: any) => {
                result.articoloRimossoList.push(ArticoloRimosso.convertFromFirestore(articolo));
            });
        }

        result.uscita = object.uscita ?? 1;
        result.nota = object.nota ?? "";

        return result;
    }

    static convertToFirestore(object: OrdineSingolo): firebase.firestore.DocumentData {
        let result: firebase.firestore.DocumentData = {};
        result.nomeAlimento = object.nomeAlimento;
        result.quantita = object.quantita;
        result.costo = object.costo;
        result.ingredienti = [];
        result.statoCompletamento = [];
        result.multipleChoice = [];
        result.singleChoice = [];
        result.choice = [];
        result.articoloRimossoList = [];
        result.id = object.articoloId ?? "";
        result.uscita = object.uscita;
        result.nota = object.nota;
        result.articoloId = object.articoloId;

        if (object.ingredienti) {
            object.ingredienti.forEach((ingrediente: any) => {
                result.ingredienti.push(OrdineIngrediente.convertToFirestore(ingrediente));
            });
        }

        /*object.multipleChoice.forEach((choice: any) => {
            result.multipleChoice.push(MultipleChoice.convertToFirestore(choice));
        });

        object.singleChoice.forEach((choice: any) => {
            result.singleChoice.push(SingleChoice.convertToFirestore(choice));
        });*/

        if (object.choice) {
            object.choice.forEach((choice: any) => {
                result.choice.push(Choice.convertToFirestore(choice));
            });
        }

        if (object.statoCompletamento) {
            object.statoCompletamento.forEach((choice: any) => {
                result.statoCompletamento.push(OrdineStatoCompletamento.convertToFirestore(choice));
            });
        }

        if (object.articoloRimossoList) {
            object.articoloRimossoList.forEach((articolo: any) => {
                result.articoloRimossoList.push(ArticoloRimosso.convertToFirestore(articolo));
            });
        }

        return result;
    }

    getFormattedSingleChoice() {
        let singleChoiceStringList: string[] = [];
        this.singleChoice.forEach(choice => {
            let sceltaUtenteIndex = choice.sceltaUtenteIndex;
            let sceltaObj = choice.sceltaUtenteList[sceltaUtenteIndex];
            singleChoiceStringList.push(" + " + sceltaObj.nome);
        });

        return singleChoiceStringList;
    }

    getFormattedMultipleChoice() {
        let multipleChoiceStringList: string[] = [];
        this.multipleChoice.forEach(choice => {
            choice.numeroAggiunteSceltaUtenteByIndex.forEach((quantitaSceltaUtente, index) => {
                let sceltaObj = choice.sceltaUtenteList[index];
                multipleChoiceStringList.push(quantitaSceltaUtente + " x " + sceltaObj.nome);
            });
        });

        return multipleChoiceStringList;
    }

    getRemovedIngredienti() {
        return this.ingredienti
            .filter(ingrediente => !ingrediente.selected)
            .map(ingrediente => " - " + ingrediente.ingrediente);
    }

    getLastStatoCompletamento(): OrdineStatoCompletamento | null {

        if (this.statoCompletamento.length === 0) {
            return null;
        }

        return this.statoCompletamento[this.statoCompletamento.length - 1];
    }
}